import React, {useMemo} from 'react'
import {organizationPermissionCodes} from 'modules/permissions/contants'
import {createCheckPermissions} from 'views/AppLocals/factory/createCheckPermissions'
import {organizationSettings} from 'views/AppLocals/Organization/Settings/OrganizationSettings'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import UnderDevelopment from '../../Shared/components/UnderDevelopment'
import OrganizationSettingRoles from '../Role/OrganizationSettingRoles'
import OrganizationPermissionMatrix from '../Role/OrganizationPermissionMatrix'
import OrganizationLabelSettings from './OrganizationLabelSettings'
import WorkspaceOrganizationFeatures from './WorkspaceOrganizationFeatures'
import WorkspaceFeatureAccessGrants from './WorkspaceFeatureAccessGrants'

// Vai trò & Vị trí / Phân quyền: organization_manage_role là owner_only trong schema BE
// (config/permissions.php) - gate đúng key này thay vì canEdit chung chung, để khớp với
// enforcement thật ở EntityRoleController (chỉ owner mới gán/thu hồi/sửa role được).
const ROLE_PERMISSIONS = [organizationPermissionCodes.organizationManageRole]

// Bật/tắt module lớn - organization_manage_features cũng owner_only (xem config/permissions.php).
const FEATURES_PERMISSIONS = [organizationPermissionCodes.organizationManageFeatures]

const EXTRA_ROUTES = [
    {key: 'entity-role', component: createCheckPermissions(ROLE_PERMISSIONS)(OrganizationSettingRoles)},
    {
        key: 'permission-role',
        component: createCheckPermissions(ROLE_PERMISSIONS)(OrganizationPermissionMatrix)
    },
    {
        key: 'feature-access-grants',
        component: createCheckPermissions(ROLE_PERMISSIONS)(WorkspaceFeatureAccessGrants)
    },
    {key: 'terminology', component: OrganizationLabelSettings},
    {key: 'feature-toggle', component: createCheckPermissions(FEATURES_PERMISSIONS)(WorkspaceOrganizationFeatures)},
    ...['system-logs', 'data-backup']
        .map(key => ({key, component: UnderDevelopment})),
].map(({key, component}) => ({key, path: key, component}))

const WorkspaceSettingContent = () => {
    const {menuItems, routeEntities: baseRoutes} = organizationSettings
    const routeEntities = useMemo(() => [...baseRoutes, ...EXTRA_ROUTES], [baseRoutes])

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        actionName: Queries.REL,
        routes: routeEntities,
    })

    return (
        <div className="px-3 space-y-3">
            <Component/>
            <div className="h-16"/>
        </div>
    )
}

export default WorkspaceSettingContent
